import styled, { keyframes } from 'styled-components';
import type { Keyframes } from 'styled-components';

export const RECORDER_EDITOR_RED_DARK = 'rgb(101, 24, 27)';
export const RECORDER_EDITOR_RED_LIGHT = 'rgb(174, 66, 62)';

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const pulseRedEditorBorder: Keyframes = keyframes`
  0%, 100% {
    border-color: ${RECORDER_EDITOR_RED_DARK};
    box-shadow: inset 0 0 0 2px ${RECORDER_EDITOR_RED_DARK};
  }

  50% {
    border-color: ${RECORDER_EDITOR_RED_LIGHT};
    box-shadow: inset 0 0 0 2px ${RECORDER_EDITOR_RED_LIGHT};
  }
`;

export const pulseRed: Keyframes = keyframes`
  0% {
    box-shadow: 0 0 0 30px rgba(144, 60, 60, 1), inset 0 0 0 0px rgba(144, 60, 60, 1);
  }

  80% {
    box-shadow: 0 0 0 30px rgba(144, 60, 60, 1), inset 0 0 0 8px rgba(144, 60, 60, 0);
  }

  100% {
    box-shadow: 0 0 0 30px rgba(144, 60, 60, 1), inset 0 0 0 8px rgba(144, 60, 60, 0);
  }
`;

export const pulseGreen: Keyframes = keyframes`
  0% {
    box-shadow: 0 0 0 30px rgba(153, 242, 175, 1), inset 0 0 0 0px rgba(153, 242, 175, 1);
  }

  80% {
    box-shadow: 0 0 0 30px rgba(153, 242, 175, 1), inset 0 0 0 8px rgba(153, 242, 175, 0);
  }

  100% {
    box-shadow: 0 0 0 30px rgba(153, 242, 175, 1), inset 0 0 0 8px rgba(153, 242, 175, 0);
  }
`;

export const pulseAIGreen: Keyframes = keyframes`
  0% {
    box-shadow: 0 0 0 30px rgba(79, 209, 197, 1), inset 0 0 0 0px rgba(79, 209, 197, 1);
  }

  80% {
    box-shadow: 0 0 0 30px rgba(79, 209, 197, 1), inset 0 0 0 8px rgba(79, 209, 197, 0);
  }

  100% {
    box-shadow: 0 0 0 30px rgba(79, 209, 197, 1), inset 0 0 0 8px rgba(79, 209, 197, 0);
  }
`;
